<div class="{{ className }}">
  <div class="{{ className }}__header">
    @if (data.errorStatus !== 402) {
      <modal-icon-title-chip-close
        (emitActions)="close()"
        [close]="true"
        [title]="(data.errorCode | errors).modalTitle"></modal-icon-title-chip-close>
    } @else {
      <span class="{{ className }}__header-simple">{{ (data.errorCode | errors).modalTitle }}</span>
    }
  </div>
  <mat-dialog-content class="{{ className }}__modal-body">
    <p class="{{ className }}__message-text">
      {{ (data.errorCode | errors: data.licenseDate).modalText }}
    </p>
  </mat-dialog-content>
  <mat-dialog-actions
    align="end"
    style="{{ data.errorStatus !== 402 && data.errorStatus !== 999 ? 'display:none' : '' }}">
    @if (data.errorStatus === 402) {
      <div class="{{ className }}__wrapper-button">
        <button
          (click)="openContactSales()"
          class="big"
          color="accent"
          id="{{ className }}__button-{{
            labelsCommon.contactSales
              | lowercase
              | replace: '_' : '-'
              | replace: ' ' : '-'
              | replace: '.' : '-'
          }}"
          mat-dialog-close
          mat-flat-button>
          {{ labelsCommon.contactSales }}
        </button>
      </div>
    }
    @if (data.errorStatus === 999) {
      <div class="{{ className }}__wrapper-button">
        <button (click)="noShowAgain()" class="big" color="primary" mat-dialog-close mat-button>
          {{ labelsCommon.noShowAgain }}
        </button>
        @if (data.userMainRole === 'role_company_admin') {
          <button
            (click)="navigateToDetails()"
            [disabled]="data.userMainRole !== 'role_company_admin'"
            class="big"
            color="accent"
            mat-dialog-close
            mat-flat-button>
            {{ labelsCommon.seeDetails }}
          </button>
        }
      </div>
    }
  </mat-dialog-actions>
</div>